
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/e-learning/[slug]/login",
      function () {
        return require("private-next-pages/e-learning/[slug]/login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/e-learning/[slug]/login"])
      });
    }
  